import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

export const useCheckUserRole = () => {
    const [isLoggedIn, setIsLoggedIn] = useState(localStorage.getItem('isLoggedIn') === 'true');
    const [userRole, setUserRole] = useState(localStorage.getItem('userRole'));
    const [userId, setUserId] = useState(localStorage.getItem('userId'));
    const [subRole, setSubRole] = useState(localStorage.getItem('subRole'));
    const navigate = useNavigate();

    const checkUserRole = async () => {
        try {
            const token = localStorage.getItem('sessionToken');
            if (!token) {
                localStorage.removeItem('userRole');
                localStorage.removeItem('isLoggedIn');
                localStorage.removeItem('userId');
                localStorage.removeItem('subRole');
                setIsLoggedIn(false);
                setUserRole(null);
                setUserId(null);
                setSubRole(null);
                navigate('/login');
                return;
            }
            const response = await fetch('/api/check_role', {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });

            if (response.ok) {
                const data = await response.json();
                const currentRole = data.role;
                const currentId = data.id;
                const currentSubRole = data.subRole;

                if (currentRole !== userRole) {
                    // Logic mismatch? If role changed, maybe we should update instead of logout?
                    // Original code logged out on role mismatch. Keep consistent but update all.
                    localStorage.removeItem('userRole');
                    localStorage.removeItem('isLoggedIn');
                    localStorage.removeItem('userId');
                    localStorage.removeItem('subRole');
                    setIsLoggedIn(false);
                    setUserRole(null);
                    setUserId(null);
                    setSubRole(null);
                    navigate('/login');
                } else {
                    setUserRole(currentRole);
                    if (currentId) {
                        setUserId(currentId);
                        localStorage.setItem('userId', currentId);
                    }
                    if (currentSubRole) {
                        setSubRole(currentSubRole);
                        localStorage.setItem('subRole', currentSubRole);
                    }
                }
            } else {
                localStorage.removeItem('userRole');
                localStorage.removeItem('isLoggedIn');
                localStorage.removeItem('userId');
                localStorage.removeItem('subRole');
                setIsLoggedIn(false);
                setUserRole(null);
                setUserId(null);
                setSubRole(null);
                navigate('/login');
            }
        } catch (error) {
            console.error('Rol Kontrol Hatası:', error);
        }
    };

    useEffect(() => {
        if (isLoggedIn) {
            checkUserRole();  // Check role on component mount
            const intervalId = setInterval(checkUserRole, 3600000);  // Check periodically
            return () => clearInterval(intervalId);
        }
    }, [isLoggedIn, userRole, navigate]);

    return { isLoggedIn, userRole, checkUserRole, userId, subRole };
};
